import type { Item } from "@/types/fse";
import { TxType } from "@/types/transaction";
import type { ItemTxProgress } from "@/views/drive/types";

export interface DriveItemProcessingState {
  progress: number;
  txType?: TxType;
  isFailed: boolean;
  errorCode?: string;
  isRejected: boolean;
  isActionable: boolean;
}

export const getDriveItemProcessingState = (item: Item, liveProgress?: ItemTxProgress): DriveItemProcessingState => {
  const transactions: Array<[number, TxType]> = liveProgress
    ? [[liveProgress.progress, liveProgress.txType]]
    : [
        ...(item.transactions?.ingestion?.progress !== undefined
          ? [[item.transactions.ingestion.progress || 0.01, TxType.UPLOAD] as [number, TxType]]
          : []),
      ].sort((left, right) => left[0] - right[0]);
  const [progress = 1, txType] = transactions[0] ?? [];
  const persistedTransaction = txType === TxType.UPLOAD ? item.transactions?.ingestion : undefined;
  const isFailed = (liveProgress ? liveProgress.status : persistedTransaction?.status) === "failed";
  const errorCode = (liveProgress ? liveProgress.errorCode : persistedTransaction?.error_code) ?? undefined;
  const isRejected = item.type === "file" && Boolean(item.rejection_reason);

  return { progress, txType, isFailed, errorCode, isRejected, isActionable: progress >= 1 && !isFailed && !isRejected };
};
